import { render, staticRenderFns } from "./PriceDiscTableSales.vue?vue&type=template&id=0330ff7d"
import script from "./PriceDiscTableSales.vue?vue&type=script&lang=js"
export * from "./PriceDiscTableSales.vue?vue&type=script&lang=js"
import style0 from "./PriceDiscTableSales.vue?vue&type=style&index=0&id=0330ff7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports